import React from 'react'
import styles from '../../../styles'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MenuItem from '@material-ui/core/MenuItem'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router'
import SelectField from '../../../components/fields/SelectField'
import selectColorEnum from '../../../enums/selectEnums/SelectColorEnum'
import selectSizeEnum from '../../../enums/selectEnums/SelectSizeEnum'
import AccordionHeader from './AccordionHeader'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			headerStyle: {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				'& h1': {
					margin: 0,
					color: theme.palette.blue.main
				}
			},
			headerLargeScreenStyle: {
				'& .col-xs-12:last-child': {
					marginTop: 25,
					textAlign: 'right',

					'& .MuiInputBase-root': {
						width: '100%',
						textAlign: 'left',
						background: 'white',
						height: 64,
						borderRadius: 32,
						padding: '0 30px',

						'& svg': {
							right: 30,
							cursor: 'pointer'
						}
					},

					'& .MuiInput-underline:before, & .MuiInput-underline:after': {
						display: 'none'
					}
				}
			},
			headerSmallScreenStyle: {
				'& .col-xs-12:last-child': {
					marginTop: 20,

					'& .MuiInputBase-root': {
						width: '100%',
						textAlign: 'left',
						background: 'white',
						height: 64,
						padding: '0 15px',

						'& .MuiSelect-root': {
							display: 'flex',
							flexDirection: 'column'
						},
						'& svg': {
							right: 25,
							cursor: 'pointer'
						}
					},

					'& .MuiInput-underline:before, & .MuiInput-underline:after': {
						display: 'none'
					}
				}
			},
			textSelect: {
				color: theme.palette.blue['50']
			},
			spanAdr: {
				padding: '0px 18px'
			},
			headerTitle: {
				textAlign: 'left'
			}
		}
	)
)

interface AcceptingProps {
	contracts: ContractsModel[],
	selectedContract: ContractsModel,
}

const CONTRACT: string = 'contract'

type HeaderProps = AcceptingProps

const Header: React.FC<HeaderProps> = (
	{
		contracts,
		selectedContract
	}
) => {
	const classes = useStyle()
	const history = useHistory()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const headerClass: ClassValue = classNames(
		classes.headerStyle,
		'row',
		{
			[classes.headerLargeScreenStyle]: isLargeScreen,
			[classes.headerSmallScreenStyle]: !isLargeScreen
		}
	)

	const headerTitleClass: ClassValue = classNames(
		classes.headerTitle,
		{
			[classes.title1]: isLargeScreen,
			[classes.title2]: !isLargeScreen
		}
	)

	const menuItemClass: ClassValue = classNames(
		classes.text7,
		classes.textSelect
	)

	const menuTitleClass: ClassValue = classNames(
		classes.text7
	)

	const menuTextClass: ClassValue = classNames(
		classes.colorBlue,
		classes.text3_opacity
	)

	const onSelectChanged = (event: React.ChangeEvent<{ value: unknown }>) => {
		history.push(
			{
				search: `?${CONTRACT}=${event.target.value}`
			}
		)
	}

	return (
		<div className={headerClass}>
			<div className="col-xs-12 col-md-5">
				<h1 className={headerTitleClass}>
					<FormattedMessage
						id="contracts.title"
						defaultMessage="Vos contrats"
						description="Contracts title"
					/>
				</h1>
			</div>

			{
				contracts.length > 1 && (
					isLargeScreen ?
						<SelectField
							inputTextStyle={menuTitleClass}
							value={selectedContract.id}
							onChange={onSelectChanged}
							backgroundColor={selectColorEnum.white}
							size={selectSizeEnum.big}
						>
							{
								contracts.map(
									(contract) => (
										<MenuItem
											value={contract.id}
											key={contract.id}
											className={menuItemClass}
										>
										<span className={menuTitleClass}>
											<FormattedMessage
												id={`dashboard.contracts.type.${contract.type}`}
												defaultMessage="Appartement"
												description="Contract type"
											/>
										</span>
											<div className={classes.spanAdr}>
												<span className={menuTextClass}>
													{contract.buildings && contract.buildings.length > 0
														? <>{contract.buildings[0].address} • {contract.buildings[0].postalCode} {contract.buildings[0].city}</>
														: contract.address
													}
												</span>
											</div>
										</MenuItem>
									)
								)
							}
						</SelectField>
						:
						<AccordionHeader contracts={contracts} selectedContract={selectedContract} />
				)
			}
		</div>
	)
}

export default Header
